import { useContext, useMemo } from 'react';

import { ThemeContext } from '../../theme/context/ThemeContext';
import { font_theme } from '../constants/font';
import { FontTheme, FontThemePartial } from '../types';

export const useFontTheme = (theme: Partial<FontThemePartial> = font_theme): FontTheme => {
  const {
    theme: {
      font: { general, color },
    },
  } = useContext(ThemeContext);

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      color: { ...color, ...theme.color },
    }),
    [general, color, theme]
  );
};
